import * as XLSX from "xlsx";

function parseDate(value) {
  if (typeof value === 'string') {
    const parts = value.split('-');
    if (parts.length === 3) {
      return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
    }
  }
  return new Date(value);
}

function formatDateCell(worksheet, row, colIndex, format = 'dd/mm/yyyy') {
  const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
  const cell = worksheet[cellRef];
  if (!cell || !cell.v) return;

  const dateValue = parseDate(cell.v);
  if (!isNaN(dateValue.getTime())) {
    cell.t = 'd';
    cell.z = format;
    cell.v = dateValue;
  }
}

function parseCurrency(value) {
  if (typeof value === 'number') return value;

  const clean = value.replace(/[$]/g, '').trim();
  let numericValue = NaN;

  if (clean.includes(',')) {
    const [intPart, decPart] = clean.split(',');
    const integer = intPart.replace(/\./g, '');
    numericValue = parseFloat(`${integer}.${decPart}`);
  } else if (clean.includes('.')) {
    const dots = (clean.match(/\./g) || []).length;
    if (dots === 1) {
      const [intPart, decPart] = clean.split('.');
      numericValue = decPart.length <= 2
        ? parseFloat(clean)
        : parseFloat(clean.replace(/\./g, ''));
    } else {
      numericValue = parseFloat(clean.replace(/\./g, ''));
    }
  } else {
    numericValue = parseFloat(clean);
  }

  return numericValue;
}

function formatCurrencyCell(worksheet, row, colIndex, format = '"$"#,##0.00') {
  const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
  const cell = worksheet[cellRef];
  if (!cell || !cell.v) return;

  const numericValue = parseCurrency(cell.v);
  if (!isNaN(numericValue)) {
    cell.v = numericValue;
    cell.t = 'n';
    cell.z = format;
  }
}


export const excelUtils = {
  formatCurrencyCell,  
  parseCurrency,
  formatDateCell,
  parseDate
};
